import { ReactElement } from 'react';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import Footer from './Footer';
import { doRefreshToken } from '../../utils';

interface Props {
  admin?: boolean;
  children: ReactElement
}

const Home = ({ admin, children }: Props): ReactElement => {
  doRefreshToken.getRefreshToken();

  return (
    <div id="wrapper">
      {admin && (
        <Sidebar />
      )}

      <div id="content-wrapper" className="d-flex flex-column">
        <Navbar admin={!admin} />
        <div id="content">
          {children}
        </div>
        <Footer />
      </div>
    </div>
  );
};

Home.defaultProps = {
  admin: undefined,
};

export default Home;
